import React, { useState } from 'react';
import AddReferenceModal from '../modals/AddReferenceModal';

const ReferencesSection = ({ isEditing, references = [], onUpdateReferences }) => {
  const [showReferenceModal, setShowReferenceModal] = useState(false);

  const handleAddReference = (referenceData) => {
    const newReference = {
      id: Date.now(),
      ...referenceData
    };
    onUpdateReferences([...references, newReference]);
    setShowReferenceModal(false);
  };

  const handleRemoveReference = (referenceId) => {
    const updatedReferences = references.filter(reference => reference.id !== referenceId);
    onUpdateReferences(updatedReferences);
  };

  const handleCopyToClipboard = (text) => {
    navigator.clipboard.writeText(text);
    // You could add a toast notification here
  };

  const maskContactInfo = (text, isVisible) => {
    if (isVisible) return text;
    
    if (text.includes('@')) {
      // Email masking
      const [username, domain] = text.split('@');
      const maskedUsername = username.substring(0, 2) + '*'.repeat(username.length - 2);
      return `${maskedUsername}@${domain}`;
    } else if (text.includes('+')) {
      // Phone masking
      const parts = text.split(' ');
      const lastPart = parts[parts.length - 1];
      const maskedLastPart = '*'.repeat(lastPart.length - 4) + lastPart.slice(-4);
      return parts.slice(0, -1).join(' ') + ' ' + maskedLastPart;
    }
    
    return text;
  };

  return (
    <div className="bg-white p-6 border border-[#E6E6E6]">
      <div className="flex items-center justify-between mb-6">
        <h2 className="text-[11px] font-bold text-[#3C3C3C]">REFERENCES</h2>
        {isEditing && (
          <button
            onClick={() => setShowReferenceModal(true)}
            className="px-4 py-2 border border-[#E6E6E6] bg-white text-[#1E1E1E] rounded-lg"
          >
            + Add References
          </button>
        )}
      </div>

      <div className="space-y-6">
        {references.length === 0 && (
          <div className="p-4 text-sm text-gray-500 border border-dashed border-gray-300 rounded-md">
            No references added yet.
          </div>
        )}
        
        {references.map((reference) => (
          <div key={reference.id} className="border-b border-[#D6DBEA] pb-6">
            <div className="flex items-start justify-between mb-4">
              <div className="text-[#222A35] text-[20px] font-bold">
                {reference.name}
              </div>
              {isEditing && (
                <button
                  onClick={() => handleRemoveReference(reference.id)}
                  className="w-8 h-8 bg-[#FF4D4F1A] border border-[#FF4D4F] rounded-full flex items-center justify-center"
                >
                  <span className="text-[#FF4D4F] text-sm font-bold">×</span>
                </button>
              )}
            </div>
            
            <div className=" flex gap-4 sm:items-center flex-col sm:flex-row">
              {/* Phone Number */}
              <div className="flex items-center gap-3 ">
                <span className="text-[#646B7E] text-[14px]">
                  {maskContactInfo(reference.phone, reference.isVisible)}
                </span>
                {reference.isVisible && (
                  <button
                    onClick={() => handleCopyToClipboard(reference.phone)}
                    className="w-6 h-6 bg-[#F8F9FB] border border-[#D6DBEA] rounded flex items-center justify-center"
                  >
                    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M4 2H2C1.44772 2 1 2.44772 1 3V9C1 9.55228 1.44772 10 2 10H8C8.55228 10 9 9.55228 9 9V7M4 2C4 1.44772 4.44772 1 5 1H9C9.55228 1 10 1.44772 10 2V6C10 6.55228 9.55228 7 9 7H5C4.44772 7 4 6.55228 4 6V2Z" stroke="#646B7E" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                  </button>
                )}
              </div>

              {/* Email */}
              <div className="flex items-center gap-3">
                <span className="text-[#646B7E] text-[14px]">
                  {maskContactInfo(reference.email, reference.isVisible)}
                </span>
                {reference.isVisible && (
                  <button
                    onClick={() => handleCopyToClipboard(reference.email)}
                    className="w-6 h-6 bg-[#F8F9FB] border border-[#D6DBEA] rounded flex items-center justify-center"
                  >
                    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M4 2H2C1.44772 2 1 2.44772 1 3V9C1 9.55228 1.44772 10 2 10H8C8.55228 10 9 9.55228 9 9V7M4 2C4 1.44772 4.44772 1 5 1H9C9.55228 1 10 1.44772 10 2V6C10 6.55228 9.55228 7 9 7H5C4.44772 7 4 6.55228 4 6V2Z" stroke="#646B7E" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                  </button>
                )}
              </div>

              {/* Recommendation Letter */}
              {reference.recommendationLetter && (
                <div className="flex items-center gap-3">
                  <span className="text-[#646B7E] text-[14px]">Letter of recommendation</span>
                  <div className="w-6 h-6 bg-[#2283FF] bg-opacity-10 rounded flex items-center justify-center">
                    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M10 2H2C1.44772 2 1 2.44772 1 3V9C1 9.55228 1.44772 10 2 10H10C10.5523 10 11 9.55228 11 9V3C11 2.44772 10.5523 2 10 2Z" stroke="#2283FF" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                      <path d="M3 4H9M3 6H9M3 8H6" stroke="#2283FF" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                  </div>
                </div>
              )}
            </div>
          </div>
        ))}
      </div>

      {/* Reference Modal */}
      {showReferenceModal && (
        <AddReferenceModal
          onClose={() => setShowReferenceModal(false)}
          onAdd={handleAddReference}
        />
      )}
    </div>
  );
};

export default ReferencesSection; 